import OrderQueueCard from "./OrderQueueCard";
import styles from "./OrdersWorkspace.module.css";

export default function OrderQueue({ orders, selectedOrderId, onSelectOrder, totalOrders }) {
  return (
    <section className={styles.queue} aria-label="Order queue">
      <header className={styles.panelHeader}>
        <strong>Order queue</strong>
        <span>{totalOrders || 0} orders</span>
      </header>
      <div className={styles.queueList}>
        {orders.map((order) => (
          <OrderQueueCard key={order.id} order={order} selected={order.id === selectedOrderId} onSelect={onSelectOrder} />
        ))}
      </div>
    </section>
  );
}
